import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import { CSSProperties } from 'react';

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 285px;
  overflow: hidden;
  display: flex;
  justify-content: center;

  @media ${mqLargeMin} {
    height: 325px;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-bottom-left-radius: var(--radius--large, 32px);
  border-bottom-right-radius: var(--radius--large, 32px);
`;

export const image: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transformOrigin: 'top',
  willChange: 'transform',
};

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  border-bottom-left-radius: var(--radius--large, 32px);
  border-bottom-right-radius: var(--radius--large, 32px);
  z-index: 1;
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: flex-end;
  padding: 0 0 32px 16px;
  max-width: 1344px;
  width: 100%;
  height: 100%;

  @media ${mqLargeMin} {
    padding: 0 0 56px 32px;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 350;
  line-height: 110%;
  letter-spacing: -0.64px;
  color: var(--text-inverse-primary, #fcfcf7);

  @media ${mqLargeMin} {
    font-size: 48px;
    letter-spacing: -0.96px;
  }
`;
